<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12" md="12">
        <material-card title="Solicitações Abertas" class="mt-3">
          <v-data-table
            :fixed-header="true"
            fix-header
            :headers="headers"
            :items="solicitacoes"
            :single-select="false"
            :footer-props="{'items-per-page-options': [10, 50, 100]}"
            :items-per-page="10"
            class="elevation-1 mt-3"
          >
            <template
              v-slot:item.usuario="{ item }"
            >{{item.usuario.nome}} - {{item.usuario.cpf | formata("documento")}}</template>
            <template v-slot:item.celular="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click="abrirWhats(item)"
                    class="ma-2"
                    tile
                    outlined
                    color="success"
                  >
                    <v-icon left>mdi-whatsapp</v-icon>
                    {{item.usuario.celular | formata("telefone") }}
                  </v-btn>
                </template>
                <span>Abrir Whatsapp</span>
              </v-tooltip>
            </template>
            <template
              v-slot:item.chave="{ item }"
            >{{item.chave === 1 ? 'BOLETOS' : 'INFO. DE PROCESSOS'}}</template>
            <template v-slot:item.dataSolicitacao="{ item }">{{item.dataSolicitacao | date}}</template>
            <template v-slot:item.acao="{ item }">
              <v-menu bottom left v-if="$vuetify.breakpoint.sm">
                <template v-slot:activator="{ on }">
                  <v-btn dark icon v-on="on" color="accent">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editItem(item)">
                    <v-list-item-title>Fechar Solicitação</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip v-if="!$vuetify.breakpoint.sm && item.chave === 1" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="lancarBoletos(item)">mdi-ballot</v-icon>
                </template>
                <span>Lançar Boletos</span>
              </v-tooltip>
              <v-tooltip v-if="!$vuetify.breakpoint.sm && item.chave === 2" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="responder(item)">mdi-arrow-top-right-thick</v-icon>
                </template>
                <span>Responder Solicitação</span>
              </v-tooltip>
            </template>
            <template v-slot:item.fechar="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" @click="fechar(item)">mdi-text-box-check</v-icon>
                </template>
                <span>Fechar Solicitação</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
    <responder-solicitacao :open-modal.sync="abrirModalResposta" :current="currentSolicitacao" :callback="callbackRespostaEfetuada"></responder-solicitacao>
  </v-container>
</template>


<script>
import { mapActions } from "vuex";
import ResponderSolicitacao from './ResponderSolicitacao';

export default {
  components: {
    ResponderSolicitacao
  },
  data() {
    return {
      solicitacoes: [],
      abrirModalResposta: false,
      currentSolicitacao: false,
    };
  },
  computed: {
    headers() {
      let headersArray = [];

      headersArray.push({
        text: "N°",
        align: "left",
        sortable: false,
        value: "id",
        class: "disabled",
      });

      headersArray.push({
        text: "Solicitação",
        align: "left",
        sortable: false,
        value: "chave",
        class: "disabled",
      });

      headersArray.push({
        text: "Cliente",
        align: "left",
        sortable: false,
        value: "usuario",
        class: "disabled",
      });

      headersArray.push({
        text: "Celular/Whatsapp",
        align: "center",
        sortable: false,
        value: "celular",
        class: "disabled",
      });

      headersArray.push({
        text: "Data Solicitação",
        align: "left",
        sortable: false,
        value: "dataSolicitacao",
        class: "disabled",
      });

      headersArray.push({
        text: "Ação",
        value: "acao",
        sortable: false,
        align: "center",
      });

      headersArray.push({
        text: "#",
        value: "fechar",
        sortable: false,
        align: "center",
      });

      return headersArray;
    },
  },
  mounted() {
    this.obterSolicitacoes();
  },
  methods: {
    ...mapActions("solicitacao", ["atualizar", "remover", "obterAbertos"]),
    callbackRespostaEfetuada() {
      this.obterSolicitacoes();
    },
    obterSolicitacoes() {
      this.obterAbertos().then((data) => {
        this.solicitacoes = data;
      });
    },
    lancarBoletos(item) {
      this.$router.push({
        name: "BoletoCpf",
        params: { cpf: item.usuario.cpf },
      });
    },
    abrirWhats(item) {
      window.open(
        `https://api.whatsapp.com/send?phone=55${item.usuario.celular}`,
        "_blank"
      );
    },
    fechar(item) {
      this.openConfirmDialog({
        message: `Confirma o fechamento da Solicitação Aberta por ${
          item.usuario.nome
        } na data de ${this.formatDate(item.dataSolicitacao)}?`,
        yes: () => {
          this.atualizar({
            id: item.id,
            idUsuario: item.usuario.id,
            chave: item.chave,
            dataSolicitacao: item.dataSolicitacao,
            resposta:
              item.chave === 1
                ? "OS BOLETOS FORAM DISPONIBILIZADOS"
                : "INFO. DE PROCESSOS FORAM ENVIADOS",
            dataResposta: new Date(),
          }).then(() => {
            this.openAlertSuccess("Solicitação encerrada com sucesso!");
            this.obterSolicitacoes();
          });
        },
      });
    },
    responder(item) {
      this.currentSolicitacao = item;
      this.abrirModalResposta = true;
    },
  },
};
</script>

<style>
</style>